import React from 'react'
import { Form as frm, InputGroup } from 'react-bootstrap'
import {
  changeHandler,
  fetchCalculation,
  prepareDisplayCalculationData
} from '../../lib/AllGlobalFunction'
import { _integerRegex_ } from '../../lib/Regex'
import ReactSelect from '../../components/ReactSelect'

const PackagingDetails = ({
  values,
  setFieldValue,
  allState,
  setCalculation,
  calculation,
  errors,
  touched
}) => {
  const calculatePackaging = async () => {
    if (
      values?.packingLength &&
      values?.packingBreadth &&
      values?.packingHeight
    ) {
      let data = {
        length: values?.packingLength,
        breadth: values?.packingBreadth,
        height: values?.packingHeight
      }
      fetchCalculation('Product/CalculatePackagingWeight', data, (data) => {
        setFieldValue('weightSlabId', data?.weightSlabId)
        setFieldValue('weightSlabName', data?.WeightSlab)
        setFieldValue('packingWeight', data?.packaging_weight)
        setCalculation({ ...calculation, packagingDetails: data })
      })

      fetchCalculation(
        'Product/DisplayCalculation',
        prepareDisplayCalculationData({
          ...values,
          weightSlabId: data?.weightSlabId
        }),
        (data) => {
          setCalculation({
            ...calculation,
            displayCalculation: data
          })
        }
      )
    }
  }
  return (
    <div className='row main_div'>
      <h5 className='mb-3 head_h3'>Packaging Details</h5>
      <div className='col-md-4 mb-3'>
        <label className='form-label' htmlFor='pl'>
          Length
        </label>
        <InputGroup>
          <frm.Control
            maxLength={7}
            name='packingLength'
            id='packingLength'
            value={values?.packingLength}
            placeholder='Length'
            onChange={(e) => {
              const inputValue = e.target.value
              const regex = /^(?:\d*\.\d+|\d+\.?|\.)$/
              if (inputValue === '' || regex.test(inputValue)) {
                setFieldValue('packingLength', e?.target?.value)
              }
            }}
            onBlur={() => {
              calculatePackaging()
            }}
          />
          <InputGroup.Text>CM</InputGroup.Text>
        </InputGroup>
      </div>
      <div className='col-md-4 mb-3'>
        <label className='form-label' htmlFor='pb'>
          Breadth
        </label>
        <InputGroup>
          <frm.Control
            maxLength={7}
            name='packingBreadth'
            id='packingBreadth'
            placeholder='Breadth'
            value={values?.packingBreadth}
            onChange={(e) => {
              const inputValue = e.target.value
              const regex = /^(?:\d*\.\d+|\d+\.?|\.)$/
              if (inputValue === '' || regex.test(inputValue)) {
                setFieldValue('packingBreadth', e?.target?.value)
              }
            }}
            onBlur={() => {
              calculatePackaging()
            }}
          />
          <InputGroup.Text>CM</InputGroup.Text>
        </InputGroup>
      </div>
      <div className='col-md-4 mb-3'>
        <label className='form-label' htmlFor='ph'>
          Height
        </label>
        <InputGroup>
          <frm.Control
            maxLength={7}
            name='packingHeight'
            id='packingHeight'
            value={values?.packingHeight}
            placeholder='Height'
            onChange={(e) => {
              const inputValue = e.target.value
              const regex = /^(?:\d*\.\d+|\d+\.?|\.)$/
              if (inputValue === '' || regex.test(inputValue)) {
                setFieldValue('packingHeight', e?.target?.value)
              }
            }}
            onBlur={() => {
              calculatePackaging()
            }}
          />
          <InputGroup.Text>CM</InputGroup.Text>
        </InputGroup>
      </div>

      <div className='col-md-4 mb-3'>
        <label className='form-label' htmlFor='pweight'>
          Weight
        </label>
        <InputGroup>
          <frm.Control
            name='packingWeight'
            disabled
            value={values?.packingWeight}
            id='packingWeight'
            placeholder='Weight'
          />
          <InputGroup.Text>KG</InputGroup.Text>
        </InputGroup>
      </div>

      <div className='col-md-6 mb-3'>
        <div className='input-file-wrapper mb-3'>
          <label className='form-label required'>Weight Slab</label>
          <ReactSelect
            id='weightSlabId'
            name='weightSlabId'
            isRequired
            errors={errors?.weightSlabId}
            touched={touched?.weightSlabId}
            placeholder='Weight Slab'
            value={
              values?.weightSlabId && {
                value: values?.weightSlabId,
                label: allState?.weight?.find(
                  (data) => data?.id === values?.weightSlabId
                )?.weightSlab
              }
            }
            options={allState?.weight?.map(({ id, weightSlab }) => ({
              label: weightSlab,
              value: id
            }))}
            onChange={(e) => {
              setFieldValue('weightSlabId', e?.value)
              setFieldValue('weightSlabName', e?.label)

              fetchCalculation(
                'Product/DisplayCalculation',
                prepareDisplayCalculationData({
                  ...values,
                  weightSlabId: e?.value ?? 0
                }),
                (data) => {
                  setCalculation({
                    ...calculation,
                    displayCalculation: data
                  })
                }
              )
            }}
          />
        </div>
      </div>
    </div>
  )
}

export default PackagingDetails
